module.exports = __webpack_public_path__ + "static/media/ic_zoom_out.ae3bbd08.svg";